import React from 'react';
import { AsButton } from '@adserve/adserve-react-components';

import { useLiveContentDayReportContext } from './contexts/LiveContentDayReportContext';

const buttonStyle = {
    height: 39,
    fontSize: 15,
    fontWeight: 500,
    marginTop: 15,
};

const InnerSelectDownload = (props) => {
  
    return (
        <AsButton
            style={buttonStyle}
            id={'liveContentDownload'}
            disabled={!props.reportData}
        >
            {window.translate('Download PDF')}
        </AsButton>
    );
}

const CachedSelectDownload = React.memo(InnerSelectDownload);

export const SelectDownload = () => {
    const { selectedLog, selectedDate, reportData } = useLiveContentDayReportContext();

    return <CachedSelectDownload
        selectedLog={selectedLog}
        selectedDate={selectedDate}
        reportData={reportData}
    />;
};